import { SourcesPanel } from './sources-panel';

interface SourcesPanelOverlayProps {
  caseId: string;
  onClose: () => void;
}

export function SourcesPanelOverlay({ caseId, onClose }: SourcesPanelOverlayProps) {
  return (
    <>
      <div className="fixed inset-0 z-20" aria-hidden="true" onClick={onClose} />
      <SourcesPanel caseId={caseId} onClose={onClose} />
    </>
  );
}
